<template>
	<popup title="Create a new automation" @close="closePopup" class="create-automation-popup">
		<template v-slot:content>
			<div class="active" :class="{}" >
				<div class="main-search">
					<input type="text" placeholder="Type to search a template..." class="main-search-input" v-model="searchInputValue">
				</div>

				<loading v-if="loading" />
				<div class="cr_autom_popup_sides" v-else-if="automationsTemplates.length > 0">
					<div class="cr_autom_left">
						<ul>
							<li
									v-for="(item, index) in recipesList"
									:key="index"
									:class="{'active': item == recipesListActive}"
									@click="recipesListSetActive(item)"
							>
								{{item}}
							</li>
						</ul>
					</div>
					<div class="cr_autom_right" style="min-height: 250px;">
						<div
								class="cr_autom_right_item"
								v-for="(item, index) in filteredTemplates"
								@click="()=>{crAutomRightItemActive = index;selectedTemplate=item;}"
								:class="{'active': crAutomRightItemActive === index}"
								:key="index"
						>
							<div class="img_wrpr">
								<img :src="item.name === 'Start from scratch' ? require('@/assets/img/template-scratch-img.svg') : require('@/assets/img/template-a-img.svg')" alt="">
							</div>
							<div class="content_wrpr">
								<h3>{{item.name}}</h3>
								<p>{{item.description}}</p>
								<span class="gray_tag">{{item.category_name}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="cr_autom_popup_sides empty_templates_list" style="min-height: 250px;" v-else>
					<p>No templates yet</p>
					<router-link :to="'/funnel/'+ funnelId +'/automations/new'" class="btn continue_btn">Create New</router-link>
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button @click="createAutomation" label="Create" :loading="creating"
			          :disabled="crAutomRightItemActive === -1" />
			<v-button label="Cancel" border @click="closePopup" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import Loading from "@/components/Loading";
export default {
	name: "new-automation-popup",
	components: {Loading, Popup, VButton},
	mixins: [API],
	data() {
		return {
			creating: false,
			loading: false,
			step: 2,
			continueBtnDisabled: true,
			searchInputValue: '',
			recipesListActive: 'All recipes',
			recipesList: [],
			funnelTypeRadio: '',
			funnelId: '',
			crAutomRightItems: [
				{
					img: require('@/assets/img/template-a-img.svg'),
					title: 'Product Interest Targeted Follow-up',
					text: 'Deliver messages that align with the product a contact is interested in. It begins when a product interest... <a>Read more</a>',
					tag: 'Start from Scratch'
				},
				{
					img: require('@/assets/img/template-scratch-img.svg'),
					title: 'Start from Scratch',
					text: 'Start from scratch with a fresh, clean slate for your automation, and add your own triggers and actions.',
					tag: 'Start from Scratch'
				},
				{
					img: require('@/assets/img/template-a-img.svg'),
					title: 'Part 1 - Engagement Tagging',
					text: 'Deliver messages that align with the product a contact is interested in. It begins when a product interest... <a>Read more</a>',
					tag: 'E-Commerce/Retail'
				},
				{
					img: require('@/assets/img/template-scratch-img.svg'),
					title: 'Site Tracking Abandoned Cart - Part 1',
					text: 'Deliver messages that align with the product a contact is interested in. It begins when a product interest... <a>Read more</a>',
					tag: 'E-Commerce/Retail'
				},
			],
			crAutomRightItemActive: -1,
			automationsTemplates: [],
			selectedTemplate: null,
		}
	},
	computed: {
		filteredTemplates() {
			var _this = this;
			var result = [];
			_this.automationsTemplates.forEach(function(templ) {
				if(
						(templ.category_name === _this.recipesListActive ||
								_this.recipesListActive === 'All recipes') &&
						templ.name.toLowerCase().includes(_this.searchInputValue.toLowerCase())
				) result.push(templ);

			});

			return result
		}
	},
	methods: {
		async createAutomation() {
			try {
				this.creating = true;
				let { id } = this.$route.params;

				let result = await this.api.automations.create(id, this.selectedTemplate.source_automation_id);
				this.$emit('done');
				this.$router.push({path: `/wfunnel/${id}/automations/${result.id}`});
			} catch (e) {
				this.$error(e);
			} finally {
				this.creating = false;
			}
		},
		closePopup() {
			this.$emit('close');
			// this.$store.commit("closeCreateAutomationPopup")
		},
		recipesListSetActive(id){
			this.recipesListActive = id;
		},
		async init(id) {
			try {
				this.loading = true;
				this.automationsTemplates = await this.api.automations.templates(id);
				let categories = ['All recipes'];
				this.automationsTemplates.forEach(template => {
					if (!categories.includes(template.category_name)) categories.push(template.category_name);
				});
				this.recipesList = categories;
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		}
	},
	mounted() {
		this.funnelId = this.$route.params.id;
		this.init(this.funnelId);
	}
}
</script>
<style lang="scss">
.create-automation-popup {
	.popup {
		position: relative;
	}
}
</style>
<style scoped lang="scss">
.cr_autom_left {
	width: 200px;
}
.cr_autom_right_item.active {
	background: $light-silver;
}
.cr_autom_right_item:hover {
	background: $light-silver;
}

.cr_autom_popup_sides.empty_templates_list {
	flex-direction: column;
	align-items: center;
	padding: 20px;
}
.cr_autom_popup_sides.empty_templates_list p {
	font-size: 14px;
}
</style>
